import React, { useState } from 'react'
import { localized, withDialogs } from 'decorators'
import MuiButton from '@material-ui/core/Button'
import { getComponentKey } from 'utils/getComponentKey'

import { Icon } from 'components/icons'
import { useStyles } from './addItemButton.css'

const AddItemButton = ({ dialogType, localize, showDialog, isEdit, onCreatedEntity, disabled, children }) => {
  const classes = useStyles()
  const [contentKey, setContentKey] = useState(getComponentKey())
  const handleClick = React.useCallback(() => showDialog({
    dialogType: dialogType,
    context: {
      entity: { id: 0 },
      onSaved: ({ entity: newEntity }) => {
        if (typeof onCreatedEntity === 'function') {
          const { id, name } = newEntity
          onCreatedEntity({ id, name })

          setContentKey(getComponentKey())
        }
      }
    }
  }), [showDialog, setContentKey, onCreatedEntity, dialogType])
  return (
    <div className={classes.root}>
      <div key={contentKey} className={classes.content}>{children}</div>
      {!disabled && <div className={classes.addButton}>
        <MuiButton
          className={classes.button}
          variant='contained'
          title={localize(isEdit ? 'common.editItemButtonTitle' : 'common.addItemButtonTitle')}
          color='primary'
          onClick={handleClick}><Icon name={isEdit ? 'pencil' : 'plus'} /></MuiButton>
      </div>}
    </div>
    
  )
}

export default withDialogs(localized(AddItemButton))
